import { Play, Settings2 } from 'lucide-react';
import type { AppEntryLinks } from '@/lib/app-entry-links';

/**
 * "Open on site" and "Open app admin" for one app (see app-entry-links.ts).
 *
 * New tabs, so the admin keeps their place here; same origin, so the tab
 * carries the admin's session and the app is embedded signed in.
 */
export default function AppEntryButtons({
  links,
  appName,
  size = 'sm',
}: {
  links: AppEntryLinks | null;
  appName: string;
  size?: 'sm' | 'md';
}) {
  const pad = size === 'md' ? 'px-3 py-1.5 text-sm' : 'px-2 py-1 text-xs';
  if (!links) {
    return (
      <span className="text-xs text-gray-500" title="Add a mount point on the app's page to put it on the site.">
        Not on the site
      </span>
    );
  }
  return (
    <>
      <a
        href={links.site}
        target="_blank"
        rel="noreferrer"
        aria-label={`Open ${appName} on the site`}
        className={`inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white font-medium text-gray-800 hover:bg-gray-50 ${pad}`}
      >
        <Play className="h-3.5 w-3.5" aria-hidden="true" /> Open on site
      </a>
      {links.admin && (
        <a
          href={links.admin}
          target="_blank"
          rel="noreferrer"
          aria-label={`Open ${appName}'s own admin`}
          className={`inline-flex items-center gap-1 rounded-md border border-blue-300 bg-blue-50 font-medium text-blue-800 hover:bg-blue-100 ${pad}`}
        >
          <Settings2 className="h-3.5 w-3.5" aria-hidden="true" /> Open app admin
        </a>
      )}
    </>
  );
}
